import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum ApplicationsErrorCode {
  ApplicationDoesNotExist = 'ApplicationDoesNotExist',
  ApplicationIsNotReady = 'ApplicationIsNotReady',
  ForbiddenPrivateApiCall = 'ForbiddenPrivateApiCall',
}

class ApplicationsError extends BaseError<ApplicationsErrorCode> {
  constructor(message: string, code: ApplicationsErrorCode) {
    super(message, code, 'Applications Private API Error');
  }

  withApplicationId(appDefinitionId: string) {
    this.state.appDefinitionId = appDefinitionId;
    return this;
  }

  withMethod(method: string) {
    this.state.method = method;
    return this;
  }

  withEnv(env: string) {
    this.state.env = env;
    return this;
  }
  withAppType(appType: string) {
    this.state.appType = appType;
    return this;
  }
}

export const createApplicationsError = createErrorBuilder<
  ApplicationsErrorCode,
  ApplicationsError
>(ApplicationsError);
